// labelTranslations defines additional distance of labels away from radar chart
// keys correspond to the number of labels in the chart
// each value is a list of transformations applied to every label
export const labelTranslations = {
  3: [
    {
      x: 0,
      y: -7,
    },
    {
      x: 7,
      y: 7,
    },
    {
      x: -7,
      y: 7,
    },
  ],
  4: [
    {
      x: 0,
      y: -9,
    },
    {
      x: 12,
      y: 0,
    },
    {
      x: 0,
      y: 17,
    },
    {
      x: -12,
      y: 0,
    },
  ],
  5: [
    {
      x: 0,
      y: -8,
    },
    {
      x: 9,
      y: -3,
    },
    {
      x: 11,
      y: 5,
    },
    {
      x: -9,
      y: 3,
    },
    {
      x: -9,
      y: 3,
    },
  ],
}

export const RADAR_COLORS = {
  single: {
    stroke: '#8ac6e4',
    fill: '#6aa6c4',
    fillOpacity: 0.6,
  },
  first: {
    stroke: '#58a892',
    fill: '#8fd0c0',
    fillOpacity: 0.35,
  },
  second: {
    stroke: '#3590ab',
    fill: '#7ecbe0',
    fillOpacity: 0.35,
  },
}

export const FIXED_RADAR_LAYOUT = {
  margin: { top: 35, right: 70, bottom: 35, left: 70 },
  outerRadius: 120,
}
